export default "__VITE_ASSET__0e71b2a4__"